// Updated NegotiateModal Component with improved responsiveness, animations, and visuals
// No functionality changed. No Tailwind used.

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlaceHolder from "../../../../assets/images/Placeholder.png";
import { toast } from "react-toastify";
import {
  Input,
  Label,
  FormGroup,
  Form,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
import {
  ReportCustomer,
  getConvoById,
} from "../../../../components/Header/Data2";
import {
  MessageStatusUpdate,
  NegotiateOffer,
} from "../../../../components/Header/Data";
import Swal from "sweetalert2";
import { debounce } from "lodash";
import {
  addIncomingMessage,
  updateSelectedConvoFields,
} from "../../../../redux/slices/MsgSlice";
import { useSocket } from "../../../../contexts/SocketContext";
import "./offers.css";

const NegotiateModal = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [history, setHistory] = useState([]);
  const [budgetThreshold, setBudgetThreshold] = useState([]);
  const [accept, setAccept] = useState(false);
  const [negotiate, setNegotiate] = useState(false);
  const [reject, setReject] = useState(false);
  const [message, setMessage] = useState("");
  const [budget, setBudget] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isAdmin = user && user.Role === "admin";
  const { selectedConvo } = useSelector((state) => state.messages);
  const { sendNewMessage } = useSocket();

  const fetchConvo = debounce(async () => {
    const messagesData = await getConvoById(selectedConvo.Id);
    const filterhistory = messagesData.filter(
      (msg) => msg.messageStatus === 6 || msg.messageStatus === 7
    );
    const negoThreshold = selectedConvo.Budget * 0.9;
    const filterThreshold = messagesData.filter(
      (message) =>
        (message.messageStatus === 6 || message.messageStatus === 7) &&
        message.createdBy !== user.UserID &&
        message.Budget <= negoThreshold
    );
    setBudgetThreshold(filterThreshold);
    setHistory(filterhistory);
  }, 300);

  const negotiateClick = () => setNegotiate(true);
  const RejectToggle = (e) => {
    e.stopPropagation();
    setReject(true);
  };
  const AcceptToggle = (e) => {
    e.stopPropagation();
    setAccept(true);
  };

  useEffect(() => {
    if (!isOpen || !selectedConvo) return;
    fetchConvo();
    return () => fetchConvo.cancel();
  }, [isOpen, selectedConvo]);

  const handleReport = async () => {
    if (isLoading) return;
    setIsLoading(true);
    if (budgetThreshold.length > 0) {
      await ReportCustomer(selectedConvo.Id);
      toast.warning(`Reported ${selectedConvo.userName.split("@")[0].trim()}`);
    }
    setIsLoading(false);
  };

  const handleConfirmPop = () => {
    Swal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) handleReport();
      closeModal();
    });
  };

  const handleRejectOffer = async () => {
    const status = {
      id: selectedConvo?.Id,
      messageStatus: selectedConvo.ownerId === user.UserID ? 5 : 10,
      updatedBy: user.UserID,
      Email: user.Email,
      needOwnerId: selectedConvo?.ownerId,
      finalBudget: selectedConvo?.finalBudget,
      serviceNeed: "need",
      ownerId: selectedConvo?.ownerId,
      postId: selectedConvo?.postId,
      customerId: selectedConvo?.customerId,
      messageComment: message,
      createdBy: selectedConvo.createdBy,
    };

    if (!status.messageComment) {
      toast.error("Enter Message");
      return;
    }

    await MessageStatusUpdate(status, selectedConvo?.Id);
    dispatch(
      updateSelectedConvoFields({
        messageStatus: status.messageStatus,
        messageComment: status.messageComment,
      })
    );

    closeModal();
    setReject(false);
    toast.success("Offer Rejected");
    setMessage("");
  };

  const handlebudget = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) value = value.substring(0, value.lastIndexOf("."));

    if (value.length <= 6) {
      const parts = value.split(".");
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        value = parts.join(".");
      }
      setBudget(value || "");
    }
  };

  const handleNegociateOffer = async () => {
    const negot = {
      Id: selectedConvo?.Id,
      customerId: selectedConvo?.createdBy,
      postId: selectedConvo?.postId,
      postType: 3,
      Description: message,
      Email: user.Email,
      messageStatus: selectedConvo.ownerId !== user.UserID ? 7 : 6,
      createdBy: user.UserID,
      roleId: user.RoleId,
      ownerId: selectedConvo?.ownerId,
      Budget: budget,
      finalBudget: budget,
      needId: selectedConvo?.postId,
      needName: selectedConvo?.postName,
      updatedBy: user.UserID,
      userName: user.UserName.split("@")[0].trim(),
      serviceNeed: "need",
      parentId:
        selectedConvo?.parentId == 0
          ? selectedConvo?.Id
          : selectedConvo?.parentId,
    };

    if (!budget) return toast.error("Enter Budget");
    if (!message) return toast.error("Enter Message");

    const res = await NegotiateOffer(negot);
    if (res.Data) {
      sendNewMessage(res.Data);
      dispatch(addIncomingMessage(res.Data));
      dispatch(
        updateSelectedConvoFields({
          messageStatus: negot.messageStatus,
          messageComment: negot.Description,
          finalBudget: negot.finalBudget,
        })
      );
    }

    closeModal();
    toast.success(`Sent Negotiation to ${budget}`);
    setBudget(null);
    setMessage("");
  };

  const handleAcceptOffer = async () => {
    const status = {
      messageStatus: selectedConvo.ownerId === user.UserID ? 4 : 9,
      updatedBy: user.UserID,
      Email: user.Email,
      parentId: selectedConvo?.parentId,
      needOwnerId: selectedConvo?.ownerId,
      finalBudget: selectedConvo?.finalBudget,
      id: selectedConvo?.Id,
      messageComment: message,
      serviceNeed: "need",
      ownerId: selectedConvo?.ownerId,
      postId: selectedConvo?.postId,
      customerId: selectedConvo?.customerId,
      createdBy: selectedConvo.createdBy,
    };

    await MessageStatusUpdate(status, selectedConvo?.Id);
    dispatch(
      updateSelectedConvoFields({
        messageStatus: status.messageStatus,
        messageComment: status.messageComment,
      })
    );

    toast.success("Offer Accepted");
    setAccept(false);
    setMessage("");
    closeModal();
  };

  function convertTo12HourFormat(time24) {
    if (!time24) return "";
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) return "";
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0");
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  function convertDate(dateStr) {
    if (!dateStr) return "";
    let date = new Date(dateStr);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return `${
      monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={closeModal}
      size="lg"
      className="hire-modal custom-animated-modal negotiation-modal"
    >
      <div>
        {/* VIEW NEGOTIATION HISTORY */}
        {selectedConvo && !negotiate && !accept && !reject ? (
          <div className="fade-in">
            <ModalHeader toggle={closeModal}>
              View Negotiation History
            </ModalHeader>
            <ModalBody className="modal-body-scroll">
              <div className="history-container p-2">
                {history &&
                  history.map((message, index) => (
                    <div
                      className="history-box shadow-sm mb-4 p-3 rounded"
                      key={index}
                    >
                      <div className="d-flex justify-content-end small text-muted">
                        {index === 0 && (
                          <span>
                            {convertDate(message?.createdAt.split("T")[0])}{" "}
                            {convertTo12HourFormat(
                              message?.createdAt.split("T")[1]
                            )}
                          </span>
                        )}
                      </div>

                      <div className="d-flex align-items-center gap-3 mt-2">
                        <img
                          src={
                            message?.messageStatus === 6
                              ? selectedConvo?.receiverProfilePhoto ||
                                PlaceHolder
                              : selectedConvo?.senderPhoto || PlaceHolder
                          }
                          alt={message?.senderName}
                          className="rounded-circle"
                          style={{ height: "60px", width: "60px" }}
                        />

                        <h5
                          className="mt-2 text-truncate"
                          style={{ maxWidth: "150px" }}
                        >
                          {message?.senderName}
                        </h5>
                      </div>

                      <div className="mt-3">
                        <Label className="fw-bold">Offer Details</Label>
                        <div className="square-details p-2 rounded border bg-light">
                          <span>{message.Message}</span>
                        </div>
                      </div>

                      <div className="mt-3">
                        <Label className="fw-bold">Price</Label>
                        <div className="square-price p-2 rounded border bg-light">
                          <span>$ {message.Budget}</span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="d-flex justify-content-start mt-3">
                {selectedConvo.createdBy === user.UserID && (
                  <span className="text-muted small">
                    <b>Note:</b> We do not allow customers to suggest prices
                    exceeding a 10% price drop from the initial offer. Vendors
                    may stay firm on their rates.
                  </span>
                )}
              </div>
            </ModalBody>
            {!isAdmin && (
              <ModalFooter className="d-flex flex-wrap justify-content-center justify-content-md-end mt-4 modal-footer-fixed">
                {selectedConvo?.zoomStatus === 6 && (
                  <button
                    className="btn btn-outline-success btn-sm mx-2"
                    onClick={AcceptToggle}
                  >
                    Accept
                  </button>
                )}
                <button
                  className="btn btn-outline-danger btn-sm mx-2"
                  onClick={RejectToggle}
                >
                  Reject
                </button>
                {selectedConvo?.zoomStatus === 6 && (
                  <button
                    className="btn btn-warning btn-sm mx-2"
                    onClick={negotiateClick}
                  >
                    Negotiate
                  </button>
                )}
                {selectedConvo.createdBy === user.UserID &&
                  budgetThreshold.length > 0 && (
                    <button
                      className="btn btn-danger btn-sm mx-2"
                      disabled={isLoading}
                      onClick={handleConfirmPop}
                    >
                      Report customer
                    </button>
                  )}
              </ModalFooter>
            )}
          </div>
        ) : !negotiate && accept ? (
          /* ACCEPT OFFER */
          <div className="fade-in">
            <ModalHeader toggle={closeModal}>Accepting Offer</ModalHeader>
            <ModalBody className="modal-body-scroll text-center">
              <b>
                Before you accept the offer or proceed with payment, please make
                sure you have discussed all deal terms in the inbox to document
                every detail.
              </b>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end mt-3 modal-footer-fixed">
              <button
                className="btn btn-success mx-2"
                onClick={handleAcceptOffer}
              >
                Accept Offer
              </button>
              <button
                className="btn btn-danger mx-2"
                onClick={() => setAccept(false)}
              >
                Go Back
              </button>
            </ModalFooter>
          </div>
        ) : !negotiate && reject ? (
          /* REJECT OFFER */
          <div className="fade-in">
            <ModalHeader toggle={closeModal}>Rejecting Offer</ModalHeader>
            <ModalBody className="modal-body-scroll text-center">
              <Form>
                <FormGroup>
                  <Label>
                    Message <b className="text-danger">*</b>
                  </Label>
                  <Input
                    type="textarea"
                    placeholder="Please explain why you are rejecting the offer..."
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end mt-3 modal-footer-fixed">
              <button className="btn btn-info mx-2" onClick={handleRejectOffer}>
                Reject Offer
              </button>
              <button
                className="btn btn-danger mx-2"
                onClick={() => setReject(false)}
              >
                Go Back
              </button>
            </ModalFooter>
          </div>
        ) : (
          /* NEGOTIATE OFFER */
          <div className="position-relative fade-in">
            <ModalHeader toggle={closeModal}>Negotiate Offer</ModalHeader>
            <ModalBody className="modal-body-scroll">
              <div className="text-center mb-4">
                <img
                  src={selectedConvo?.senderPhoto || PlaceHolder}
                  alt="profile"
                  className="rounded-circle shadow"
                  style={{ height: "70px", width: "70px" }}
                />
                <h5 className="mt-2 fw-bold">
                  {selectedConvo?.createdBy === user?.UserID
                    ? selectedConvo?.userName.split("@")[0].trim()
                    : selectedConvo?.senderName}
                </h5>
              </div>
              <Form className="mt-4">
                <FormGroup>
                  <Label>
                    Package Price <b className="text-danger">*</b>
                  </Label>
                  <Input
                    type="number"
                    placeholder="$00.00"
                    onChange={handlebudget}
                  />
                </FormGroup>

                {selectedConvo.ownerId === user.UserID &&
                  budget &&
                  budget < selectedConvo.finalBudget * 0.9 && (
                    <div className="text-danger small">
                      You may not suggest price drops exceeding 10% of the
                      initial offer ({selectedConvo.finalBudget})
                    </div>
                  )}

                <FormGroup className="mt-3">
                  <Label>
                    Message <b className="text-danger">*</b>
                  </Label>
                  <Input
                    type="textarea"
                    placeholder="Type message.."
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </FormGroup>
              </Form>
              {selectedConvo?.createdBy !== user?.UserID && (
                <p className="mt-2 small text-muted">
                  <b>Note:</b> Negotiation drops cannot exceed 10% of the
                  initial offer. Vendors may stay firm.
                </p>
              )}
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end mt-4 modal-footer-fixed">
              <button
                className="btn btn-warning mx-2"
                onClick={handleNegociateOffer}
              >
                Negotiate Offer
              </button>
              <button
                className="btn btn-danger mx-2"
                onClick={() => setNegotiate(false)}
              >
                Go Back
              </button>
            </ModalFooter>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default NegotiateModal;
